import api from "../client.ts";

type ParentType = {
  id: number | null;
  personne_id: number;
  status: number;
  created_at: string; // ISO timestamp string
  updated_at: string; // ISO timestamp string
  nom: string;
  postnom: string;
  prenom: string;
  sexe: 'M' | 'F'; // assuming only 'M' or 'F' are valid
  adresse_id: number;
  telephone: string;
  ville: string;
  commune: string;
  quartier: string;
  avenue: string;
  parent_id: number;
  email: string;
  profession: string;
  type: string;

};

const getAll = async ():Promise<{size:number, data: ParentType[]}> => {
  const { data } = await api.get("/parent/readAll");
  return data;
};

const create = async (newRecord:any) => {
  const { data } = await api.post("/parent/create",newRecord);
  return data;
};

const update = async (id:any, newUser:any) => {
  const { data } = await api.put(`/parent/update?id=${id}`, newUser);
  return data;
};

const desactivate = async (id:any) => {
  const { data } = await api.get(`/parent/desactive?id=${id}`);
  return data;
};
const activate = async (id:any) => {
  const { data } = await api.get(`/parent/active?id=${id}`);
  return data;
};


export const parentController = {getAll,create, activate,desactivate, update}